import NLPService from '@/services/NLPService.js';

const documents = {
  namespaced: true,

  state: {
    // estado con los tipos de dominios
    documentTypes: [],
    // estado para alamcenar los documentos
    documents: []
  },

  mutations: {
  },

  actions: {
    /**
     * Acciones para el modulo de procesamiento de lenguaje natural
     * 1- getNer: acion para obetenr los dominios de documentos
     */
    async getNer({ commit }, text) {
      /**
       * Accion para realizar procesamiento NER
       *
       * @param {Object} context datos del modulo
       * @param {Object} documentData datos del documento
       * @example
       * $store.dispatch('nlp/getNer', 'NOTARIA 1A. de B/BERMEJA.')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      console.log('getNer', text);
      try {
        const token = localStorage.getItem('token');
        const response = await NLPService.getNer(text, token);
        if (response) {
          return { obtained: true, ner: response.data };
        }
        return { obtained: false, ner: [] };
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al obtener el NER
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { obtained: false, ner: [] };
      }
    },
  },
};

export default documents;
